var _path, _path2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditHolidays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 91V4.5L91 47L15 91Z",
    fill: "#FC6A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 69V13L54 40.5145L6 69Z",
    stroke: "black",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 69.5,
    y1: 15.5,
    x2: 69.5,
    y2: 67.5,
    stroke: "#16161E",
    strokeWidth: 5,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 83.5,
    y1: 15.5,
    x2: 83.5,
    y2: 67.5,
    stroke: "#16161E",
    strokeWidth: 5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditHolidays);
export default __webpack_public_path__ + "static/media/credit_holidays.b64c67ac256b8b438fb4e729dc2e430d.svg";
export { ForwardRef as ReactComponent };